// src/bootstrap/http/errors.js

import axios from 'axios'
import Vue from 'vue'
import * as Sentry from '@sentry/vue'

// ---------- AXIOS ----------
axios.interceptors.response.use(
  response => response,
  error => {
    // Network error or server crash
    if (!error.response || error.response.status >= 500) {
      Sentry.captureException(error)
    }

    return Promise.reject(error)
  }
)

// ---------- VUE-RESOURCE ----------
Vue.http.interceptors.push((request, next) => {
  next(response => {
    // vue-resource uses response.ok
    if (!response.ok && response.status >= 500) {
      const error = new Error(`HTTP ${response.status}`)
      error.request = request
      error.response = response

      Sentry.captureException(error)
    }

    return response
  })
})
